<template>
	<div class="tile-offset" :style="transform">
		<slot></slot>
	</div>
</template>

<script>
import random from '@/mixins/random';

export default {
	name: 'TileOffset',
	mixins: [random],
	props: ["flipY"],
	inject: ["offset"],
	computed: {
		offsetMin() {
			return Array.isArray(this.offset.offset_amount)
				? this.offset.offset_amount[0] : -this.offset.offset_amount;
		},
		offsetMax() {
			return Array.isArray(this.offset.offset_amount)
				? this.offset.offset_amount[1] : this.offset.offset_amount;
		},
		offsetAmount() {
			return this.offset.offset_amount;
		},
		transform() {
			let offset = '';

			if (this.offset.offset) {
				offset = `translate(${this.offsetX}%, ${this.offsetY}%)`;
			}

			return {
				transform: `${offset} ${this.rotation}`,
			};
		},
		offsetX() {
			return this.randomBetween(this.offsetMin, this.offsetMax);
		},
		offsetY() {
			return this.randomBetween(this.offsetMin, this.offsetMax);
		},
		rotateX() {
			return !this.flipY && this.offset.flip && this.randomBoolean() ? 1 : 0;
		},
		rotateY() {
			return this.flipY ? 1 : 0;
		},
		rotateZ() {
			return !this.rotateY && !this.rotateX && this.offset.flip && this.randomBoolean() ? 1 : 0;
		},
		rotation() {
			return `rotate3d(${this.rotateX}, ${this.rotateY}, ${this.rotateZ}, 180deg)`;
		},
	},
};
</script>

<style lang="scss" scoped>
	.tile-offset {
		@include cover;
		touch-action: manipulation;
		pointer-events: none;
	}
</style>



// WEBPACK FOOTER //
// src/components/board/TileOffset.vue